import { useRegisterSW } from "virtual:pwa-register/react";
import { isNative } from "@/lib/native";
import { Button } from "./ui/button";
import { t } from "@shared/i18n";

/** PWA : propose de recharger quand une nouvelle version est disponible (pas de mise à jour silencieuse). */
function Prompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  if (!needRefresh) return null;
  return (
    <div role="status" className="fixed bottom-24 left-1/2 z-50 flex w-[calc(100vw-32px)] max-w-md -translate-x-1/2 items-center gap-3 glass-card p-3 pl-4 shadow-card lg:bottom-6">
      <p className="flex-1 text-sm">{t("Une nouvelle version de GBC Coach IA est disponible.")}</p>
      <Button size="sm" variant="ghost" onClick={() => setNeedRefresh(false)}>
        {t("Plus tard")}
      </Button>
      <Button size="sm" onClick={() => updateServiceWorker(true)}>
        {t("Mettre à jour")}
      </Button>
    </div>
  );
}

export function UpdatePrompt() {
  // Les apps natives sont mises à jour via les stores ; pas de service worker.
  if (isNative || import.meta.env.DEV) return null;
  return <Prompt />;
}
